import React from "react";
import { JSQ_SUPPORT_EMAIL, JSQ_PHONE } from "common/constants/copy";
import { Column, ColumnContainer } from "@jsq/ds/layouts";
import { RichEmptyState, Link, Card } from "@jsq/ds/core";
import styles from "./styles.scss";

const NotFoundPage = () => (
  <ColumnContainer>
    <Column size="lg" className={styles.Column}>
      <Card className={styles.Card}>
        <RichEmptyState
          title="There's nothing here"
          illustration="internal-error"
          description={
            <p className={styles.Description}>
              This page may have been moved, deleted, or you may not have permission to access
              it. If you arrived here from an email from Juniper Square, the link may be expired
              or no longer valid. For assistance, please contact us at{" "}
              <Link isInline href={`mailto:${JSQ_SUPPORT_EMAIL}`}>
                {JSQ_SUPPORT_EMAIL}
              </Link>{" "}
              or {JSQ_PHONE}.
            </p>
          }
        />
      </Card>
    </Column>
  </ColumnContainer>
);

export { NotFoundPage };
